import React from "react";
import "./PromptModal.css";

const PromptModal = ({
  title,
  type,
  handleClose,
  showModal,
  handleConsent,
  isLoading,
}) => {
  if (!showModal) {
    return null; // Return null if the modal is not open
  }
  const modalTypeRender = () => {
    switch (type) {
      case "binary":
        return (
          <div className="prompt-modal-actions">
            <button
              className="prompt-btn prompt-deny-btn"
              onClick={handleClose}
            >
              No
            </button>
            <button
              className="prompt-btn prompt-confirm-btn"
              onClick={handleConsent}
            >
              Yes
            </button>
          </div>
        );
      case "alert":
        return (
          <div className="prompt-modal-actions">
            <button className="prompt-btn prompt-ok-btn" onClick={handleClose}>
              OK
            </button>
          </div>
        );
      default:
        return <></>;
    }
  };

  return (
    <div className="prompt-modal-overlay" onClick={handleClose}>
      {!isLoading ? (
        <div
          className="prompt-modal-content"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="prompt-modal-header">
            <h3>Notification</h3>
          </div>
          <div className="prompt-modal-body">
            <p>{title}</p>
          </div>
          {modalTypeRender()}
        </div>
      ) : (
        <div
          className="prompt-modal-loading"
          onClick={(e) => e.stopPropagation()}
        >
          <img
            src={require("../../images/loading_icon.gif")}
            alt="Clock icon"
          />
        </div>
      )}
    </div>
  );
};

export default PromptModal;
